export { default as DynamicMap } from './DynamicMapboxMap';
export { default as StaticMap } from './StaticMapboxMap';

export const isMapsLibLoaded = () => {
  return (
    typeof window !== 'undefined' &&
    window.mapboxgl &&
    // Require accessToken to be present to avoid race where GL is loaded
    // but token hasn't been set yet (due to deferred script loading)
    Boolean(window.mapboxgl.accessToken)
  );
};
